import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as fromActions from '../actions/settings.actions';
import { AumicoSettingsService } from '../services/aumico-settings.service';
import { getDebug, getTag } from '../utils/debugUtil';

import { ActionWithPayload } from '@modeso/aumico-lib-core-fe';
import { IFilterOptions } from '../interfaces/filter-options.interface';

const filename = './src/lib/effects/legal-form.effects.ts';
const debug = getDebug(filename);
const TAG = getTag(filename);

@Injectable()
export class LegalFormEffects {
    constructor(private actions$: Actions, private service: AumicoSettingsService) {}

    getAllLegalForm$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.legalFormActions.getAllLegalForm),
            mergeMap(({ payload }: ActionWithPayload<IFilterOptions | undefined>) => {
                return this.service.getAllLegalForm(payload).pipe(
                    map((response) => {
                        return fromActions.legalFormActions.onGetAllLegalFormSuccess({ payload: response });
                    }),
                    catchError((error) => {
                        return of(fromActions.legalFormActions.onGetAllLegalFormFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    submitCreateLegalForm$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.legalFormActions.submitCreateLegalForm),
            mergeMap((action) => {
                const observable$ = this.service.createLegalForm(action.payload);
                return observable$.pipe(
                    map(() => {
                        return fromActions.legalFormActions.onSubmitCreateLegalFormSuccess();
                    }),
                    catchError((error) => {
                        return of(fromActions.legalFormActions.onSubmitCreateLegalFormFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    submitEditLegalForm$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.legalFormActions.submitEditLegalForm),
            mergeMap((action) => {
                const observable$ = this.service.updateLegalForm(action);
                return observable$.pipe(
                    map(() => {
                        return fromActions.legalFormActions.onSubmitEditLegalFormSuccess();
                    }),
                    catchError((error) => {
                        return of(fromActions.legalFormActions.onSubmitEditLegalFormFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );
}
